<template>
  <!-- <div class="container-fluid mt--6"> -->
    <div class="row">
      <div class="col">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-0">
            <h3 class="mb-0">All Pages</h3>
          </div>
          <!-- Light table -->
          <div class="table-responsive">
            <table class="table align-items-center table-flush">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="sort" data-sort="name">Name</th>
                  <th scope="col">Eddress</th>
                  <th scope="col">Description</th>
                  <th scope="col" class="sort" data-sort="budget"></th>
                  <th scope="col" class="sort" data-sort="status"></th>
                  <th scope="col" class="sort" data-sort="completion">

                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody class="list">
                <router-link :to="{ name: 'PageProfile', params: { id: page.id } }" tag='tr' v-for="(page) in pages" :key="page.id">
                  <th scope="row">
                    <div class="media align-items-center">
                      <!-- <a href="#" class="avatar rounded-circle mr-3">
                        <img
                          alt="Image placeholder"
                          src="/assets/img/theme/bootstrap.jpg"
                        />
                      </a> -->
                      <div class="media-body">
                        <span class="name mb-0 text-sm"
                          >{{page.name}}</span
                        >
                      </div>
                    </div>
                  </th>
                  <td class="budget">
                    {{page.eddress}}
                  </td>
                  <td>
                    <span class="badge badge-dot mr-4">
                      <!-- <i class="bg-warning"></i> -->
                      <span class="status">{{page.description.substring(0, 30)+'...'}}</span>
                    </span>
                  </td>
                  <td>
                    <!-- {{page.eddress}} -->
                  </td>
                  <td>
                  <!-- {{page.descriprion}} -->
                  </td>
                  <td class="text-right">
                    <!-- <div class="dropdown">
                      <a
                        class="btn btn-sm btn-icon-only text-light"
                        href="#"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-ellipsis-v"></i>
                      </a>
                      <div
                        class="dropdown-menu dropdown-menu-right dropdown-menu-arrow"
                      >
                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <a class="dropdown-item" href="#"
                          >Something else here</a
                        >
                      </div>
                    </div> -->
                  </td>
                </router-link>

              </tbody>
            </table>
          </div>
          <!-- Card footer -->
          <div class="card-footer py-4">
            <nav aria-label="...">
              <ul class="pagination justify-content-end mb-0">
                <li class="page-item disabled">
                  <a class="page-link" href="#" tabindex="-1">
                    <i class="fas fa-angle-left"></i>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link" href="#">1</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#"
                    >2 <span class="sr-only">(current)</span></a
                  >
                </li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    <i class="fas fa-angle-right"></i>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'Pages',
  data () {
    return {
      pages: [
        {
          id: 1,
          name: 'Chigisoft',
          eddress: 'GraceLand',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, reprehenderit praesentium quasi assumenda quas atque minima exercitationem molestiae aliquid tempore!'
        },
        {
          id: 2,
          name: 'Fufu Joint',
          eddress: 'Bode Thomas Allen',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, reprehenderit praesentium quasi assumenda quas atque minima exercitationem molestiae aliquid tempore!'
        },
        {
          id: 3,
          name: 'Stamford Bridge',
          eddress: 'Buckingham Palace',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, reprehenderit praesentium quasi assumenda quas atque minima exercitationem molestiae aliquid tempore!'
        },
        {
          id: 4,
          name: 'dike',
          eddress: 'dike@yahoo.com',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, reprehenderit praesentium quasi assumenda quas atque minima exercitationem molestiae aliquid tempore!'
        },
        {
          id: 5,
          name: 'supardyke',
          eddress: 'supardyke@dike.com',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, reprehenderit praesentium quasi assumenda quas atque minima exercitationem molestiae aliquid tempore!'
        }
      ]
    }
  },
  mounted () {
    this.getPages()
  },
  methods: {
    async getPages () {
      try {
        const res = await this.$store.dispatch('pages/getPages')
        if (!res) return
        // this.pages = res.data
        console.log(res.data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
tr {
  cursor: pointer;
}
</style>
